import type {Size} from '@jetbrains/ring-ui/components/avatar/avatar'
import RingAvatar from '@jetbrains/ring-ui/components/avatar/avatar'
import classNames from 'classnames'

import styles from './Avatar.css'

type Props = {
  className: string | undefined
  withOutline: boolean
  mine: boolean
  highlightMyChanges: boolean
  size: Size
  avatarClassName: string | undefined
  avatar: string | null | undefined
  avatar2x: string | null | undefined
  username: string | undefined
  round?: boolean
}

function Avatar(props: Props) {
  return (
    <span
      className={classNames(styles.wrapper, props.className, {
        [styles.withOutline]: props.withOutline,
        [styles.my]: props.mine && props.highlightMyChanges,
      })}
      style={{height: props.size, width: props.size}}
      data-ignore-dark-theme-adapter
    >
      <RingAvatar
        className={classNames(styles.avatar, props.avatarClassName)}
        url={props.avatar2x ?? props.avatar}
        srcSet={
          props.avatar && props.avatar2x ? `${props.avatar}, ${props.avatar2x} 2x` : undefined
        }
        size={props.size}
        username={props.username}
        skipParams
        round={props.round}
      />
    </span>
  )
}

export default Avatar
